
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/strategy/fs5_us",
      function () {
        return require("private-next-pages/strategy/fs5_us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/strategy/fs5_us"])
      });
    }
  